import classNames from "classnames";
import { ColumnSortContainer } from "../column-sort-container/column-sort-container";
import styles from "./table-header-column.less";
import { FilterFnOption, flexRender, Header } from "@tanstack/react-table";
import { TextInputFilter } from "@containers/common/text-input-filter/text-input-filter";
import { SelectInputFilter } from "@containers/common/select-input-filter/select-input-filter";
import { SelectOption } from "@iddataweb/idw-common-ui/types";

type TableHeaderColumnProps<T> = {
    header: Header<T, unknown>;
    colSpan: number;
    id: string;
};

export const TableHeaderColumn = <T extends object>(props: TableHeaderColumnProps<T>) => {
    const { header, colSpan, id } = props;

    const filterFn: FilterFnOption<T> = header.column.columnDef?.filterFn;

    const generateFilter = () => {
        let options: Array<SelectOption> = [];
        const selectFilterOptions: Array<FilterFnOption<T>> = ["singleSelectFilter", "multiSelectFilter"];

        if (selectFilterOptions.includes(filterFn)) {
            options = header.column.columnDef.meta?.filterOptions || [];
        }

        switch (filterFn) {
            case "fuzzyText":
            case "dateFilter":
            case "dateTimeFilter":
            case "changeRequestStatusFilter":
                return <TextInputFilter column={header.column} />;
            case "singleSelectFilter":
                return <SelectInputFilter options={options} column={header.column} />;
            case "multiSelectFilter":
                return <SelectInputFilter options={options} column={header.column} isMulti={true} />;
            default:
                return null;
        }
    }

    return (
        <th className={styles.tableHeaderColumn} colSpan={colSpan} role="columnheader">
            <div
                className={classNames(styles.tableHeaderInfo, (header.column.getCanFilter() && filterFn) ? styles.marginBottom : "")}
                onClick={header.column.getToggleSortingHandler()}
            >
                <span id={id} className={styles.headerElement}>
                    {flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                    )}
                </span>
                {header.column.getCanSort() && (
                    <ColumnSortContainer
                        id={`${id}-sort`}
                        isSorted={header.column.getIsSorted()}
                    />
                )}
            </div>
            <div className={styles.tableHeaderFilter}>
                {(header.column.getCanFilter() && filterFn) && (
                    generateFilter()
                )}
            </div>
        </th>
    );
};